module.exports = __webpack_public_path__ + "img/icon4.9712591d.svg";